import React from "react";
import ChrCollapsible from "../../../generic/Utils/ChrCollapsible";
import { getContentComponent, isAStandaloneComponent } from "../../../generic/Utils/commonUtils";
import useActionsBuilder from "../../../../hooks/generic/Actions/useActionsBuilder";

/*
props = {
  getContentComponentFn: <function>
  data: {
    uId: <uniqueIdentifier>,
    title: <string>,
    collapsed: <boolean>,
    collapsible: <boolean>,
    contents: [ props for <Widget /> or <ChrMetric />, ...]
  }
}
*/

const Section = (props) => {
  const {
    title, contents,
    uId, collapsed, collapsible,
    hover, noHeader
  } = props.data;
  const { actions } = useActionsBuilder(props.data.actionsData || {});

  const contentClass = isAStandaloneComponent(contents) ? "" : "grid-container-lg cui-grid-template-2-columns-min-400"

  const collapsibleConfig = {
    title,
    uId,
    collapsible,
    collapsed,
    hover,
    contentClass,
    headerActions: actions.headerActions
  };

  const getSectionContent = () => {
    return(
      contents.map((content) => {
        const contentComponentGetter = props.getContentComponentFn || getContentComponent;
        const ContentComponent = contentComponentGetter(content);
        if (ContentComponent) {
          return <ContentComponent key={ content.uId } { ...content } />;
        }
      })
    );
  }

  if(noHeader) {
    return <div className={`${contentClass}`}>{ getSectionContent() }</div>
  }

  return (
    <ChrCollapsible {...collapsibleConfig} >
      { getSectionContent() }
    </ChrCollapsible>
  );
};

export default Section;
